import moneyComboBook from 'assets/images/moneyCombo.jpg';

import {
  ONLY_PURCHASE,
  LOGIN,
  ADDRESS,
  PAYMENT,
  THANKS,
  PASSWORD,
  FIRST_NAME,
  LAST_NAME,
  ZIP_CODE,
  CITY,
  COUNTRY,
  EMAIL,
  GIFT_BOOK,
  FLIP_BOOKS,
  ACCOUNT_BOOK,
} from '../const';

import { getThanksForMoneyCombo3 } from './utils';

const moneyCombo3 = {
  book: {
    id: 'money-combo-3',
    format: FLIP_BOOKS,
    title: 'Money-Combo-3',
    subtitle: 'Voucher for a one-year Premium subscription',
    price: [100],
    introductions: [
      {
        type: 'textWithList',
        text: 'With the Fintool Money Combo, you receive',
        list: ['an annual subscription to Fintool-Premium worth CHF 100', 'the latest FlipBook by Erwin Heri'],
      },
      'The combo worth CHF 139',
    ],
    image: moneyComboBook,
  },
  bookIds: [38],
  getDefaultOption: ({ isPremium, isBasic }) => (isBasic && 1) || (!isPremium && 2) || 0,
  getDefaultStrictMode: ({ isPremium, isBasic }) => Boolean(isBasic || isPremium),
  orderOptions: [ACCOUNT_BOOK, GIFT_BOOK],
  purchases: [
    {
      id: 1,
      name: 'Fintool Premium Subscriber',
      tasks: {
        [LOGIN]: () => ({
          banner: {
            title: 'Fintool Premium Subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [100, 139],
            propositions: ['FlipBook', '12 months Fintool-Premium'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [EMAIL, PASSWORD],
            submitButton: 'Login',
            showAdb: false,
          },
          nextStep: 1,
        }),
        [ADDRESS]: () => ({
          banner: {
            title: 'Fintool Premium Subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [100, 139],
            propositions: ['FlipBook', '12 months Fintool-Premium'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [ADDRESS, ZIP_CODE, CITY, COUNTRY],
            submitButton: 'Continue',
            showAdb: false,
          },
          navigation: '1/2',
          nextStep: 2,
        }),
        [PAYMENT]: () => ({
          banner: {
            title: 'Fintool Premium Subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [100, 139],
            propositions: ['FlipBook', '12 months Fintool-Premium'],
          },
          form: { withPromoCode: false },
          navigation: '2/2',
          prevStep: 1,
          nextStep: 3,
          shouldSignUp: false,
          subscribeId: null,
          productId: 38,
        }),
        [THANKS]: getThanksForMoneyCombo3,
      },
    },
    {
      id: 2,
      name: 'Fintool Basic subscriber',
      tasks: {
        [LOGIN]: () => ({
          banner: {
            title: 'Fintool Basic subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [100, 139],
            propositions: ['FlipBook', '12 months Fintool-Premium'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [EMAIL, PASSWORD],
            submitButton: 'Login',
            showAdb: false,
          },
          nextStep: 1,
        }),
        [ADDRESS]: () => ({
          banner: {
            title: 'Fintool Basic subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [100, 139],
            propositions: ['FlipBook', '12 months Fintool-Premium'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [ADDRESS, ZIP_CODE, CITY, COUNTRY],
            submitButton: 'Continue',
            showAdb: false,
          },
          navigation: '1/2',
          nextStep: 2,
        }),
        [PAYMENT]: () => ({
          banner: {
            title: 'Fintool Basic subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [100, 139],
            propositions: ['FlipBook', '12 months Fintool-Premium'],
          },
          form: { withPromoCode: false },
          navigation: '2/2',
          prevStep: 1,
          nextStep: 3,
          shouldSignUp: false,
          subscribeId: null,
          productId: 38,
        }),
        [THANKS]: getThanksForMoneyCombo3,
      },
    },
    {
      id: 3,
      name: 'No subscription',
      tasks: {
        [ONLY_PURCHASE]: () => ({
          banner: {
            title: 'Not a Fintool subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [100, 139],
            propositions: ['FlipBook', '12 months Fintool-Premium'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [FIRST_NAME, LAST_NAME, ADDRESS, ZIP_CODE, CITY, COUNTRY, EMAIL],
            submitButton: 'Continue',
            showAdb: false,
          },
          navigation: '1/2',
          nextStep: 1,
        }),
        [PAYMENT]: () => ({
          banner: {
            title: 'Not a Fintool subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [100, 139],
            propositions: ['FlipBook', '12 months Fintool-Premium'],
          },
          form: { withPromoCode: false },
          navigation: '2/2',
          prevStep: 0,
          nextStep: 2,
          shouldSignUp: false,
          subscribeId: null,
          productId: 38,
        }),
        [THANKS]: getThanksForMoneyCombo3,
      },
    },
  ],
};

export default moneyCombo3;
